import React from "react";
import DataItem from "../Components/DataItem";

import ReasonForm from "../Forms/ReasonForm";

export default class UnfilledTrips extends React.Component {

    constructor(){
        super();
        this.state = {
            trips: [],
            reasonFormOpen: false,
            cancelIndex: null
        }
    }

    componentDidMount(){
        console.log("UNFILLED TRIPS PROPS", this.props.data);
        this.setData();
    }

    componentDidUpdate(prevProps) {
        if(this.props.data !== this.state.trips){
            this.setData();
        }
    }

    setData() {
        this.setState({trips: this.props.data});
    }

    cancel = (index) => {
        this.setState({reasonFormOpen: true, cancelIndex: index});
    }
    
    runCancelWithReason = (reason) => {
        const index = this.state.cancelIndex;
        console.log("REASON AND INDEX?", reason, index);
        this.setState({reasonFormOpen: false, cancelIndex: null});
        this.props.cancel(index, reason);
    }

    render() {
        return (
            <>
            {this.props.data 
                ? this.state.trips.map((trip, index) => {
                    return <UnfilledTripRecord key={index} index={index} bus={trip} cancel={this.cancel} />
                })
                : null
            }
            {
                this.state.reasonFormOpen
                ? <ReasonForm submitReason={this.runCancelWithReason} />
                : null
            }
            </>
        )
    }
}

const UnfilledTripRecord = (props) => {

    const timeIndex = props.bus.SchedDepTime.indexOf(" ");
    const time = props.bus.SchedDepTime.substr(timeIndex);

    const cancel = () => {
        const prompt = window.confirm("Are you sure you want to mark this trip as lost?");
        if(prompt){
            props.cancel(props.index);
        }
    }

    // #ddaa77

    return (
        <div className="data trip-card shadow-card" style={{backgroundColor: "rgb(245 179 179)", color:"#444"}}>
        <div style={{backgroundColor: "#666"}}></div>
        <div className="trip-inner-grid" style={{
            alignItems: "center"
        }}>
            <div>
            </div>
            <div><DataItem val={time} /></div>
            <div style={{
                gridRow: "1/3",
                gridColumn: "3/4"
            }}>
                {
                    props.bus.DelayReason === "Cancelled"
                    ? <span>Trip Lost</span>
                    : <button onClick={cancel} className="option">Trip Lost</button>
                }
            </div>
            <div>
                Dest: <DataItem val={props.bus.Header} />
            </div>
            <div>
                Route: <DataItem val={props.bus.Route} />
            </div>
            <div>L/G: <DataItem val={props.bus.SchedLaneGate} /></div>
            <div style={{
                width: "100%",
                paddingRight: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <span>
                    Original Bus
                </span>
                <span>
                    Run: <DataItem val={props.bus.run_id_original} />
                </span>
                <span>
                    Bus#: <DataItem val={props.bus.vehicle_id_original} />
                </span>
            </div>
        </div>
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            fontWeight: "bold",
            backgroundColor: "#666",
            color: "white",
            padding: "0.2vh 0 0.5vh 0"
        }}>
            <span>
                Trip
            </span>
            <span>
                Not
            </span>
            <span>
                Filled
            </span>
        </div>
    </div>
    )
}